import * as JobCodes from '../constants/JobCodes';

const JobCodeList = () => ([
    {   code: '',
        name: 'None',
    },
    {
        code: JobCodes.RELIABILITY_ENGINEER,
        name: 'Reliability Engineer',
    },
    {
        code: JobCodes.ASSOCIATE_RELIABILITY_ENGINEER,
        name: 'Associate Reliability Engineer',
    },
    {
        code: JobCodes.SENIOR_APPLICATION_DEVELOPER,
        name: 'Senior Application Developer',
    },
    {
        code: JobCodes.APPLICATION_DEVELOPER,
        name: 'Application Developer',
    },
    {
        code: JobCodes.ASSOCIATE_APPLICATION_DEVELOPER,
        name: 'Associate Application Developer',
    },
    {
        code: JobCodes.SENIOR_BUSINESS_SYSTEM_ANALYST,
        name: 'Senior Business System Analyst',
    },
    {
        code: JobCodes.BUSINESS_SYSTEM_ANALYST,
        name: 'Business System Analyst',
    },
    {
        code: JobCodes.ASSOCIATE_BUSINESS_SYSTEM_ANALYST,
        name: 'Associate Business System Analyst',
    },
    {
        code: JobCodes.QUALITY_SUPERINTENDENT,
        name: 'Quality Superintendent',
    },
    {
        code: JobCodes.QUALITY_SUPERINTENDENT_II,
        name: 'Quality Superintendent II',
    },
    {
        code: JobCodes.SENIOR_QUALITY_SYSTEMS_ANALYST,
        name: 'Senior Quality System Analyst',
    },
    {
        code: JobCodes.QUALITY_SYSTEMS_ANALYST,
        name: 'Quality System Analyst',
    },
    {
        code: JobCodes.MANAGER_I_QUALITY,
        name: 'Manager I - Quality',
    },
    {
        code: JobCodes.FIELD_PROCESS_IMPROVEMENT_SPECIALIST,
        name: 'Field Process Improvement Specialist',
    },
    {
        code: JobCodes.QUALITY_SPECIALIST,
        name: 'Quality Specialist',
    },
    {
        code: JobCodes.ASSOCIATE_TALENT_DEVELOPMENT_PARTNER,
        name: 'Associate Talent Development Partner',
    },
])

const List = JobCodeList();

export default List;
